import { useEffect, useState } from "react";
import Dropzone from "react-dropzone";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
} from "@mui/material";
import CustomButton from "../ui/button/Button";

const ModalSubirArchivo = ({
  open,
  onClose,
  onConfirm,
  accept = { "application/pdf": [], "video/*": [] },
}) => {
  const [file, setFile] = useState(null);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  useEffect(() => {
    if (open) {
      setFile(null);
    }
  }, [open]);

  const handleClose = () => {
    setFile(null);
    onClose();
  };

  const handleConfirm = () => {
    if (file) {
      onConfirm(file);
      handleClose();
    } else {
      setShowSnackbar(true);
      setSnackbarMessage(
        "Por favor, selecciona un archivo antes de confirmar."
      );
    }
  };

  return (
    <Dialog fullWidth maxWidth="md" open={open} onClose={handleClose}>
      <Snackbar
        open={showSnackbar}
        autoHideDuration={3000}
        onClose={() => {
          setShowSnackbar(false);
          setSnackbarMessage("");
        }}
        message={snackbarMessage}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        slotProps={{
          content: {
            sx: {
              backgroundColor: "white",
              color: "#222",
              justifyContent: "center",
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "16px",
              fontFamily: "Roboto, Arial, sans-serif",
            },
          },
        }}
      />
      <DialogTitle>Subir Archivo</DialogTitle>
      <DialogContent>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
          }}
        >
          <Dropzone
            accept={accept}
            multiple={false}
            onDrop={(acceptedFiles) => {
              const file = acceptedFiles?.[0];
              if (file) {
                setFile(file);
              }
            }}
          >
            {({ getRootProps, getInputProps, isDragActive }) => (
              <section
                className="editor-drop-area"
                style={{
                  backgroundColor: isDragActive ? "#eef7ff" : "#f9f9f9",
                }}
              >
                <div {...getRootProps()} style={{ padding: "40px" }}>
                  <input {...getInputProps()} />
                  <p>{"Seleccionar o arrastrar archivo"}</p>
                </div>
              </section>
            )}
          </Dropzone>
          {file && (
            <div>
              Archivo seleccionado: <h2>{file.name}</h2>
            </div>
          )}
        </div>
      </DialogContent>
      <DialogActions>
        <CustomButton
          background={"#FFFFFF"}
          color={"#223D51"}
          text="Cerrar"
          height="40px"
          fontWeight="700"
          fontSize="14px"
          border="1px solid #D9D9D9"
          type="button"
          width={"100px"}
          onClick={handleClose}
        />
        <CustomButton
          background={"#223D51"}
          color={"#FFFFFF"}
          text="Subir"
          height="40px"
          fontWeight="700"
          fontSize="14px"
          border="1px solid #D9D9D9"
          type="button"
          width={"100px"}
          onClick={handleConfirm}
        />
      </DialogActions>
    </Dialog>
  );
};

export default ModalSubirArchivo;
